import React, { useState } from "react";

const PackageDetailsModal = ({ isOpen, onClose, onSave, packageDetails, setPackageDetails }) => {
    const [errors, setErrors] = useState({});

    if (!isOpen) return null;

    const handleSave = () => {
        const newErrors = {};
        if (!packageDetails.length) newErrors.length = "Required";
        if (!packageDetails.width) newErrors.width = "Required";
        if (!packageDetails.height) newErrors.height = "Required";
        if (!packageDetails.weight) newErrors.weight = "Required";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setErrors({});
        onSave(packageDetails);
        onClose();
    };

    const handleChange = (field, value) => {
        setPackageDetails({ ...packageDetails, [field]: value });
        if (errors[field]) {
            setErrors({ ...errors, [field]: null });
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg w-96 shadow-xl">
                <h2 className="text-[12px] sm:text-[14px] text-gray-700 font-[600] mb-2">Enter Package Details</h2>

                <div className="grid grid-cols-2 gap-4 mb-4">
                    {/* Length */}
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Length"
                            value={packageDetails.length}
                            onChange={(e) => handleChange("length", e.target.value)}
                            className={`border-2 border-gray-300 p-2 pr-10 rounded-lg focus:outline-none text-[12px] placeholder:text-[12px] placeholder:font-[600] w-full ${errors.length ? "border-red-500" : ""
                                }`}
                        />
                        <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-[10px] font-[600]">cm</span>
                        {errors.length && <p className="text-[10px] text-red-500 mt-1">Length is required</p>}
                    </div>

                    {/* Width */}
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Width"
                            value={packageDetails.width}
                            onChange={(e) => handleChange("width", e.target.value)}
                            className={`border-2 border-gray-300 p-2 pr-10 rounded-lg focus:outline-none text-[12px] placeholder:text-[12px] placeholder:font-[600] w-full ${errors.width ? "border-red-500" : ""
                                }`}
                        />
                        <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-[10px] font-[600]">cm</span>
                        {errors.width && <p className="text-[10px] text-red-500 mt-1">Width is required</p>}
                    </div>

                    {/* Height */}
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Height"
                            value={packageDetails.height}
                            onChange={(e) => handleChange("height", e.target.value)}
                            className={`border-2 border-gray-300 p-2 pr-10 rounded-lg focus:outline-none text-[12px] placeholder:text-[12px] placeholder:font-[600] w-full ${errors.height ? "border-red-500" : ""
                                }`}
                        />
                        <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-[10px] font-[600]">cm</span>
                        {errors.height && <p className="text-[10px] text-red-500 mt-1">Height is required</p>}
                    </div>

                    {/* Weight */}
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Weight"
                            value={packageDetails.weight}
                            onChange={(e) => handleChange("weight", e.target.value)}
                            className={`border-2 border-gray-300 p-2 pr-10 rounded-lg focus:outline-none text-[12px] placeholder:text-[12px] placeholder:font-[600] w-full ${errors.weight ? "border-red-500" : ""
                                }`}
                        />
                        <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-[10px] font-[600]">kg</span>
                        {errors.weight && <p className="text-[10px] text-red-500 mt-1">Weight is required</p>}
                    </div>
                </div>

                <div className="flex justify-end gap-2">
                    <button
                        onClick={onClose}
                        className="px-3 py-2 text-[10px] sm:text-[12px] rounded-lg border-2 text-gray-500 font-[600] border-gray-300"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}
                        className="px-3 py-2 text-[10px] sm:text-[12px] rounded-lg bg-[#632C9D] font-[600] text-white"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PackageDetailsModal;
